import { render, staticRenderFns } from "./Services.vue?vue&type=template&id=330c663f"
import script from "./Services.vue?vue&type=script&lang=js"
export * from "./Services.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('330c663f')) {
      api.createRecord('330c663f', component.options)
    } else {
      api.reload('330c663f', component.options)
    }
    module.hot.accept("./Services.vue?vue&type=template&id=330c663f", function () {
      api.rerender('330c663f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/referentiel/service/Services.vue"
export default component.exports